const noRecipe = [{
"id": 0,
"title": "No Recipe Selected",
"slug": "",
"authorFirstName": "",
"authorLastName": "",
"isbn": "",
"purchaseLinks": "",
"coverImage": "",
"publisher": "",
"dateAdded": "",
"datePublished": "",
"dustCoverText": "",
"excerpts": "",
"reading_level": ""
}];

class RecipeApi {

	static filterRecipes(recipes,filter,sort) {
		//filter
		let filteredRecipes = recipes;
		//sort
		let filteredAndSortedRecipes = filteredRecipes; //.map(function(thisBook){ //get array of books by looping through library's books			
		// 	let book = books.filter(b => b._id.$oid == thisBook);
		// 	return book[0]; 
		// });
		//filteredAndSortedRecipes.sort(function(a, b) {
			//let x = a[sort] < b[sort] ? -1:1; 
			//return x;
			// switch(sort) {
			// 	case "id": {
			// 		return parseFloat(a.id) - parseFloat(b.id); //sort by field value. reverse these for ASC/DESC
			// 	}
			// 	case "dateAdded": {
			// 		return parseFloat(a.dateAdded) - parseFloat(b.dateAdded); //sort by field value. reverse these for ASC/DESC
			// 	}
			// 	case "id": {
			// 		return parseFloat(a.id) - parseFloat(b.id); //sort by field value. reverse these for ASC/DESC
			// 	}
			// 	case "id": {
			// 		return parseFloat(a.id) - parseFloat(b.id); //sort by field value. reverse these for ASC/DESC
			// 	}
			// }
		//});

		return filteredAndSortedRecipes;
	}

	static loadRecipe(recipeId) {
		return new Promise((resolve, reject) => {
			$.ajax('https://api.mlab.com/api/1/databases/lbuilder/collections/recipes?q={"id":' + recipeId + '}&apiKey=GN4bcW6HsxOlxO8yg-u9octqRt7gg7Sa')
			.success(function(thisRecipe) {
				if (thisRecipe.length != 0) {
					resolve(thisRecipe);
				} else {
					resolve(noRecipe);
				}
			});
		});
	}

	static loadRecipes(collection,filter=[],sort="dateAdded") {
		let functions = this;
		if (collection.length == 0) { //get no recipes
			return new Promise((resolve, reject) => {
				resolve(Object.assign([], []));
			});
		} else { //get all recipes (browse)
			return new Promise((resolve, reject) => {
				$.ajax('https://api.mlab.com/api/1/databases/lbuilder/collections/recipes?s={"id": 1}&apiKey=GN4bcW6HsxOlxO8yg-u9octqRt7gg7Sa')
				.success(function(recipes) {
					let filteredAndSortedRecipes = functions.filterRecipes(recipes,filter,sort);
					resolve(Object.assign([], filteredAndSortedRecipes));
				});
			});
		}
	}

}

export default RecipeApi;


/** WEBPACK FOOTER **
 ** ./src/api/mockRecipeApi.js
 **/